// extracted by mini-css-extract-plugin
export default {"pageTitle":"styles-module__pageTitle--qi6gQ","isCenterOnMobile":"styles-module__isCenterOnMobile--B3Bbn"};